import React from "react";
import {
  FaGlobe,
  FaMobileAlt,
  FaRocket,
  FaBrain,
  FaSearch,
} from "react-icons/fa";
import "./Services.css";

const servicesData = [
  {
    title: "Full Stack Development",
    icon: <FaGlobe />,
    description:
      "Creating responsive, accessible & modern web experiences ( MERN / NextJs / RemixJs / NestJs ).",
  },
  {
    title: "Mobile App Development",
    icon: <FaMobileAlt />,
    description:
      "(Exclusively in Expo Framework) Cross‑platform mobile apps with performant, native‑feeling UI & smooth UX.",
  },
  {
    title: "Deployment",
    icon: <FaRocket />,
    description:
      "(Will exclusively use gh_actions, k8s, docker, and vercel) Containerized CI/CD pipelines & production rollouts with Kubernetes / Cloud. (vercel, supabase)",
  },
  {
    title: "AI Development",
    icon: <FaBrain />,
    description:
      "Integrating LLMs & ML workflows for intelligent, data‑driven products.",
  },
  {
    title: "SEO Optimization",
    icon: <FaSearch />,
    description:
      "Performance tuning & structured strategies to boost organic discovery.",
  },
];

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="services-header">
        <p className="services-subtitle">What I Offer</p>
        <h2 className="services-title">Services</h2>
        <p className="services-intro">
          From concept to deployment & growth – end‑to‑end support for modern
          digital products.
        </p>
      </div>
      <div className="services-container" role="list">
        {servicesData.map((service, index) => (
          <div
            className="services-item"
            role="listitem"
            key={service.title}
            style={{ "--delay": `${index * 80}ms` }}
          >
            <div className="service-icon" aria-hidden="true">
              {service.icon}
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
